<template>
    <div v-if="mostrar" class="modal-mask" @click="fechar">
        <div class="jm margem modal-historico-pedidos" @click.stop>
            <div class="modal-historico-cabecalho">
                <div>
                    <h2>Pedidos de mudança</h2>
                    <p v-if="tituloProjeto" class="modal-historico-subtitulo">
                        <template v-if="pcmCodigo">{{ pcmCodigo }} · </template>{{ tituloProjeto }}
                    </p>
                </div>
                <button type="button" class="acao-secundaria btn-fechar-modal" aria-label="Fechar"
                    @click="fechar">
                    <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
            </div>

            <div v-if="carregando" class="loading" role="status" aria-label="Carregando pedidos">
                <div></div>
            </div>

            <div v-else-if="erro" class="alinha-centro">
                <span class="chip bg-erro">{{ erro }}</span>
            </div>

            <div v-else class="modal-historico-corpo">
                <PedidosMudancaLista :pedidos="pedidos" />
            </div>

            <div class="submit direita modal-historico-acoes">
                <button type="button" class="acao-secundaria" @click="fechar">Fechar</button>
            </div>
        </div>
    </div>
</template>

<script>
import servicePCM from '@/services/servicePCM'
import PedidosMudancaLista from '@/components/Gestão/PedidosMudancaLista.vue'

export default {
    name: 'ModalHistoricoPedidosMudanca',

    components: { PedidosMudancaLista },

    props: {
        mostrar: {
            type: Boolean,
            default: false,
        },
        pcmId: {
            type: [Number, String],
            default: null,
        },
        tituloProjeto: {
            type: String,
            default: '',
        },
        pcmCodigo: {
            type: String,
            default: '',
        },
    },

    emits: ['fechar'],

    data() {
        return {
            carregando: false,
            pedidos: [],
            erro: null,
        }
    },

    watch: {
        mostrar(aberto) {
            if (aberto) {
                this.carregarPedidos()
            } else {
                this.pedidos = []
                this.erro = null
            }
        },
    },

    methods: {
        fechar() {
            this.$emit('fechar')
        },

        async carregarPedidos() {
            if (!this.pcmId) {
                this.erro = 'PCM não encontrado para este projeto.'
                return
            }

            this.carregando = true
            this.erro = null
            try {
                const response = await servicePCM.getPedidosEdicao(this.pcmId)
                const lista = Array.isArray(response) ? response : []
                lista.forEach((item) => {
                    if (item.campo === 'estimativa_custo' && item.valor_atual != null) {
                        item.valor_atual = parseFloat(item.valor_atual).toFixed(2)
                    }
                    if (item.campo === 'estimativa_custo' && item.novo_valor != null) {
                        item.novo_valor = parseFloat(item.novo_valor).toFixed(2)
                    }
                })
                this.pedidos = lista
            } catch {
                this.erro = 'Não foi possível carregar os pedidos de mudança.'
            } finally {
                this.carregando = false
            }
        },
    },
}
</script>

<style scoped>
.modal-historico-pedidos {
    width: min(56rem, 96vw);
    max-height: 90vh;
    display: flex;
    flex-direction: column;
}

.modal-historico-cabecalho {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.modal-historico-cabecalho h2 {
    margin: 0 0 0.35rem;
}

.modal-historico-subtitulo {
    margin: 0;
    font-size: 0.9rem;
    opacity: 0.8;
}

.btn-fechar-modal {
    flex-shrink: 0;
    width: 2.25rem;
    height: 2.25rem;
    padding: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.modal-historico-corpo {
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    padding-right: 0.25rem;
}

.modal-historico-acoes {
    margin-top: 1rem;
    padding-top: 0.75rem;
    border-top: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.1));
}
</style>
